import { ProtectedRoute } from "@/components/protected-route";
import { RoleGuard } from "@/components/role-guard";
import { ROLES } from "@/constants/users";
import { DashboardLayout } from "@/layouts/dashboard-layout";
import {
  AuthGoogleCallback,
  DashboardPage,
  LoginLogsPage,
  LoginPage,
  Profile,
  ResetPasswordPage,
  UserLogsPage,
  UsersPage,
} from "@/pages";
import { Navigate, createBrowserRouter } from "react-router-dom";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/google-auth/callback",
    element: <AuthGoogleCallback />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          {
            path: "/",
            element: <Navigate to="/dashboard" />,
          },
          {
            path: "/profile",
            element: <Profile />,
          },
          {
            path: "/dashboard",
            element: <DashboardPage />,
          },
          {
            path: "/users",
            element: (
              <RoleGuard roles={[ROLES.ADMIN]}>
                <UsersPage />
              </RoleGuard>
            ),
          },
          {
            path: "/logs/user-logs",
            element: (
              <RoleGuard roles={[ROLES.ADMIN]}>
                <UserLogsPage />
              </RoleGuard>
            ),
          },
          {
            path: "/logs/login-logs",
            element: (
              <RoleGuard roles={[ROLES.ADMIN]}>
                <LoginLogsPage />
              </RoleGuard>
            ),
          },
        ],
      },
      {
        path: "/reset-password",
        element: <ResetPasswordPage />,
      },
    ],
  },
]);
